export const loadedScriptsCache = new Set<string>();